import 'floating-vue/dist/style.css'
import 'leaflet/dist/leaflet.css'
import './assets/styles/main.css'

import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import HoneybadgerVue from '@honeybadger-io/vue'
import FloatingVue from 'floating-vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { hasAccessDirective, hasAccessMixin } from './mixins/hasAccess.mixin'
import { useNotificationStore } from '@/stores/notification'
import { getLocalVersion } from '@/utils/version-checker'

import App from './App.vue'
import router from './router'
import 'flowbite'

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

const config = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_HONEYBADGER_ENVIRONMENT,
  revision: import.meta.env.VITE_HONEYBADGER_REVISION
}

pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(head)
app.use(HoneybadgerVue, config)
app.use(FloatingVue)
app.directive('has-access', hasAccessDirective)
app.mixin(hasAccessMixin)

app.$honeybadger.beforeNotify((notice) => {
  const message = notice.message || ''
  const ignoredErrorPatterns = (import.meta.env.VITE_IGNORED_ERROR_PATTERNS || '')
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean)

  // Custom logic for triggering app reload prompt
  const reloadTriggers = [
    'is not a valid JavaScript MIME type',
    'Unable to preload CSS',
    'Failed to fetch dynamically imported module'
  ]

  notice.context = {
    ...(notice.context || {}),
    assetsVersion: getLocalVersion()
  }

  if (reloadTriggers.some((trigger) => message.includes(trigger))) {
    const notificationStore = useNotificationStore()
    notificationStore.notifyReload = true
    return false
  }

  // Check against environment-driven ignore list
  const shouldIgnore = ignoredErrorPatterns.some((pattern) => message.includes(pattern))

  return !shouldIgnore
})

app.mount('#app')
